import { getLandingPage } from "@/lib/drupal/util"
import { DrupalTaxonomyTermProduct } from "@/types"
import Link from "next/link"
import { HTMLAttributes } from "react"

interface AddOnsMenuProps extends HTMLAttributes<any> {
    title?: string
    terms: Promise<DrupalTaxonomyTermProduct[]>
}

export async function AddOnsMenu({ terms, title = 'Add Ons', ...props }: AddOnsMenuProps) {
    const links = await terms
    if (links.length < 1) {
        return <></>
    }
    return (
        <div {...props}>
            <h3 className="p-2">{title}</h3>
            <nav className="flex flex-col">
                { links.map((term) => {
                    return (
                        <Link key={`term-${term.drupal_internal__tid}`} className="hover:bg-gray-500 p-2 font-medium rounded-lg" href={getLandingPage(term) ?? '#'}>{term.name}</Link>
                    )
                }) }
            </nav>
        </div>
    )
}